/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getSystemstatus } from '../fn/system-status/get-systemstatus';
import { GetSystemstatus$Params } from '../fn/system-status/get-systemstatus';
import { PlatformSystemStatusDto } from '../models/platform-system-status-dto';


/**
 * Statuspaneel in het beheer (docs/BEHEER.md): UptimeRobot, de back-upcheck in
 * Healthchecks.io en de eigen health checks. De API-sleutels blijven hier; de frontend ziet
 * enkel de statussen. Beheerrecht vereist (issue #51, ControllerAuthorizationTests).
 */
@Injectable({ providedIn: 'root' })
export class PlatformSystemStatusService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSystemstatus()` */
  static readonly GetSystemstatusPath = '/api/SystemStatus';

  /**
   * De status van alle bronnen. Altijd 200: een bron die niet ingesteld, geweigerd of
   * onbereikbaar is, meldt dat in haar eigen blok. Kort gecachet (SystemStatus:CacheSeconds).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSystemstatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSystemstatus$Response(params?: GetSystemstatus$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformSystemStatusDto>> {
    return getSystemstatus(this.http, this.rootUrl, params, context);
  }

  /**
   * De status van alle bronnen. Altijd 200: een bron die niet ingesteld, geweigerd of
   * onbereikbaar is, meldt dat in haar eigen blok. Kort gecachet (SystemStatus:CacheSeconds).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSystemstatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSystemstatus(params?: GetSystemstatus$Params, context?: HttpContext): Observable<PlatformSystemStatusDto> {
    return this.getSystemstatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformSystemStatusDto>): PlatformSystemStatusDto => r.body)
    );
  }

}
